<script lang="ts">
  import { klarnaRegion } from '$lib/region';

  export let purchaseAmount: number;
</script>

<klarna-placement
  data-key="credit-promotion-badge"
  data-locale={$klarnaRegion}
  data-purchase-amount={purchaseAmount}
/>

<style lang="postcss">
  :global(*::part(osm-container)) {
    @apply bg-transparent mb-0 px-0 py-2 lg:py-3 border-x-0 border-y-0 border-primary/4;
  }

  :global(*::part(osm-badge)) {
    width: 60px;
    height: 30px;
  }

  :global(*::part(osm-message)) {
    @apply font-sans -ml-1;
  }

  :global(*::part(osm-legal)) {
    @apply font-sans -ml-1 mt-0 text-primary/40;
  }

  :global(*::part(osm-cta)) {
    @apply font-sans text-primary;
  }
</style>
